import React, { useMemo, useState } from 'react';
import { Plus } from 'lucide-react';
import { ExportMenu } from '../components/export/ExportMenu';
import { StudentTable } from '../components/students/StudentTable';
import { StudentTableSkeleton } from '../components/students/StudentTableSkeleton';
import { StudentToolbar, type StudentFilters } from '../components/students/StudentToolbar';
import { StudentsEmptyState } from '../components/students/StudentsEmptyState';
import { Button } from '../components/ui/Button';
import { useStudents } from '../contexts/StudentsContext';
import { filterStudents, sortStudents, uniqueClasses } from '../utils/stats';
const initialFilters: StudentFilters = {
  search: '',
  sort: 'newest',
  gender: '',
  className: ''
};
export function Students() {
  const {
    students,
    loading,
    openCreateForm
  } = useStudents();
  const [filters, setFilters] = useState<StudentFilters>(initialFilters);
  const classes = useMemo(() => uniqueClasses(students), [students]);
  const visible = useMemo(() => sortStudents(filterStudents(students, filters.search, filters.gender, filters.className), filters.sort), [students, filters]);
  return <div className="mx-auto w-full max-w-7xl space-y-5" data-id="element-705" data-mp="2pe07sblpqy3h">
      <section className="glass flex flex-col gap-4 rounded-3xl p-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-706" data-mp="2ue4mpx6z3krl">
        <div data-id="element-707" data-mp="2z7gxp4iqbt1v">
          <h2 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl" data-id="element-708" data-mp="2z7z4gv30ppo1">Student records</h2>
          <p className="mt-1.5 text-sm text-muted-foreground" data-id="element-709" data-mp="347bpdaabwmnz">
            Read live from the Supabase <span className="font-mono" data-id="element-710" data-mp="3966h51q9xlk8">students</span> table — every change appears
            instantly.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2" data-id="element-711" data-mp="3i4i9p9apatfb">
          <ExportMenu data-id="element-712" data-mp="3i2nvsexuk1kq" />
          <Button onClick={openCreateForm} className="h-9 rounded-xl brand-gradient px-4 text-white shadow-lg shadow-indigo-500/25 hover:opacity-95" data-id="element-713" data-mp="1irnvsrk7u7cy">
            <Plus className="mr-1.5 h-4 w-4" data-id="element-714" data-mp="1nsk89timv1tz" />
            Add Student
          </Button>
        </div>
      </section>

      <section className="glass overflow-hidden rounded-3xl" aria-label="Student records table" data-id="element-715" data-mp="2m2tisfaf18ib">
        <StudentToolbar filters={filters} onChange={setFilters} classes={classes} resultCount={visible.length} totalCount={students.length} data-id="element-716" data-mp="302305iacy8nv" />

        {loading ? <StudentTableSkeleton data-id="element-717" data-mp="39zpgm97b289y" /> : students.length === 0 ? <StudentsEmptyState variant="no-records" onAddStudent={openCreateForm} data-id="element-718" data-mp="351foy8kshpt3" /> : visible.length === 0 ? <StudentsEmptyState variant="no-matches" onAddStudent={openCreateForm} onClearFilters={() => setFilters(initialFilters)} data-id="element-719" data-mp="3it2ii0nckk86" /> : <StudentTable students={visible} data-id="element-720" data-mp="3sqh0i4ox5h2l" />}
      </section>
    </div>;
}